<div class="hours">
  <svg-icon src="/assets/icons/clock.svg" class="hidden-print" [ngClass]="{ closed: !isOpenToday }"></svg-icon>
  <h4 *ngIf="isOpenToday" class="title-hours today hidden-print">
    Open Today &middot; {{ todayStartTime }} - {{ todayFinishTime }}
  </h4>
  <h4 *ngIf="!isOpenToday" class="title-hours closed hidden-print">Closed Today</h4>
  <h4 class="title-hours hidden-screen">Hours</h4>

  <ul class="hours-list">
    <li *ngFor="let day of hours.days">
      {{ day.day.charAt(0) | uppercase }}:
      <span *ngIf="day.isOpen; else closed">{{ day.start | lowercase }} - {{ day.finish | lowercase }}</span>
    </li>
  </ul>
</div>
<ng-template #closed>Closed</ng-template>
